<script setup lang="ts">
import ButtonBase, { type ButtonBaseProps } from "@/components/BaseButton.vue";

const props = withDefaults(
  defineProps<ButtonBaseProps & { highlight?: boolean }>(),
  {
    rounded: true,
    shadow: true,
  }
)
</script>

<template>
  <ButtonBase :class="[$style['button-secondary'], {
    [$style['highlight']]: props.highlight
  }]" class="btn-outline-secondary" v-bind="props" :shadow="highlight ? false : shadow">
    <slot />
  </ButtonBase>
</template>

<style lang="scss" module>
@import "@/assets/variables";
@import "@/assets/bootstrap-variables";

$highlight-color: #fee351;

.button-secondary {
  --#{$prefix}btn-color: #{$body-color};
  --#{$prefix}btn-bg: #fff;
  --#{$prefix}btn-hover-bg: #eee;
  --#{$prefix}btn-hover-color: var(--#{$prefix}btn-color);
  --#{$prefix}btn-hover-border-color: var(--#{$prefix}btn-border-color);
  --#{$prefix}btn-border-color: #d1d1d1;
  --#{$prefix}btn-disabled-border-color: #d1d1d1;
  --#{$prefix}btn-active-bg: var(--#{$prefix}-btn-bg);
  --#{$prefix}btn-active-color: #{$body-color};
}

.highlight {
  background-color: $highlight-color;
  color: $body-color;
  border: none;
  animation: none;

  &:hover, &:focus {
    background-color: darken($highlight-color, 17%);
    border-color: darken($highlight-color, 20%);
  }

  &:disabled {
    background-color: $highlight-color;
    border-color: darken($highlight-color, 19%);
  }
}
</style>
